<template>
  <div
    class="invadobay-preview__side-card"
    :class="{ 'invadobay-preview__side-card--wide': wide }"
  >
    <!-- single-invadobay preview: a carousel of the invadobay's hotels -->
    <invadobay-search-preview-hotels
      v-if="wide"
      :invadobay="elem"
      :loading="loading"
      :properties="properties"
      :checkin="suggested_dates.checkin"
      :checkout="suggested_dates.checkout"
    />
    <!-- properties -->
    <invadobay-search-preview-properties
      v-else
      :invadobay="elem"
      :loading="loading"
      :properties="properties"
    />

    <!-- content -->
    <b-card class="invadobay-preview__side-card__info card">
      <div class="h-100 d-flex flex-column gap-3 justify-content-center">
        <custom-link
          :route_path="`/invadobay/${elem.slug}`"
          :wrapper_class="'invadobay-preview__side-card__info_title'"
          :as_default="get_config('guiSettings.openDetailNewTab', false)"
        >
          <template #content>
            {{ elem.title }}
          </template>
        </custom-link>
        <p
          v-if="elem.description"
          :id="`description_text-${elem.description}-${_uid}`"
          ref="description_text"
          class="invadobay-preview__side-card__info_description" 
        >
          {{ elem.description }}
        </p>
        <b-popover
          v-if="description_tooltip"
          :target="`description_text-${elem.description}-${_uid}`"
          triggers="hover"
          placement="bottom"
          custom-class="b-popover--dark b-popover--no-arrow"
        >
          <span class="text--base">
            {{ description_tooltip }}
          </span>
        </b-popover>
        <p class="w-100 d-flex justify-content-end">
          <custom-link
            :route_path="`/invadobay/${elem.slug}`"
            :css_class="'text-info link'"
            :as_default="get_config('guiSettings.openDetailNewTab', false)"
          >
            <template #content> Vedi tutte le proposte </template>
          </custom-link>
        </p>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { get_suggested_booking_dates } from "@liveeps/utilities";
import { search_invadobay_preview_properties } from "./utilities";
import { get_config } from "@/utilities/commons";
import InvadobaySearchPreviewProperties from "./invadobay-search-preview-properties.vue";
import InvadobaySearchPreviewHotels from "./invadobay-search-preview-hotels.vue";

export default {
  name: "invadobay-search-preview",
  components: {
    "invadobay-search-preview-properties": InvadobaySearchPreviewProperties,
    "invadobay-search-preview-hotels": InvadobaySearchPreviewHotels,
  },
  props: {
    elem: Object,
    wide: Boolean,
  },
  data() {
    return {
      loading: true,
      properties: [],
      description_tooltip: "",
    };
  },
  computed: {
    ...mapState(["occupancy"]),
    suggested_dates() {
      return get_suggested_booking_dates({
        date_start: this.elem.search_period_start,
        date_end: this.elem.search_period_end,
      });
    },
  },
  mounted() {
    const search_promise = search_invadobay_preview_properties(
      this.elem,
      this.occupancy
    );
    if (search_promise) {
      search_promise
        .then((success) => {
          this.properties = success.data.data.properties;
        })
        .finally(() => {
          this.loading = false;
        });
    }
    this.$nextTick(() => {
      this.description_tooltip = this.is_text_truncated(
        this.$refs.description_text
      )
        ? this.elem.description
        : "";
    });
  },
  methods: {
    get_config,
  },
};
</script>

<style lang="scss" scoped>
.invadobay-preview__side-card {
  margin-bottom: $grid-gutter-width;
  display: grid;
  grid-template-columns: 100%;
  gap: 5px;

  @include media-breakpoint-up(lg) {
    gap: 15px;
    grid-template-columns: min(50%, 345px) auto;
  }

  // Single-invadobay preview: the info card sits on the left (capped) and the
  // property+rooms slider fills the rest of the row on the right. DOM order is
  // kept (slider first) for the standard layout, so we reorder via CSS.
  &--wide {
    @include media-breakpoint-up(lg) {
      grid-template-columns: min(50%, 345px) minmax(0, 1fr);

      .invadobay-preview__side-card__info {
        order: -1;
      }
    }
  }

  &__info {
    border-radius: $border-radius-lg * 2 !important;
    border: 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &_title {
      color: black;
      font-size: $font-size-xl;
      font-weight: $vb-font-weight-semibold;
      text-decoration: underline;
    }

    &_link {
      color: $info;
      font-weight: $vb-font-weight-semibold;
      text-decoration: underline;
    }

    &_description {
      height: 4lh;

      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4; /* Limita a 3 righe */

      box-orient: vertical;
      line-clamp: 4;

      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
